import { useState } from 'react';
import FreeResourceModal from '../../../components/FreeResourceModal';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showAll, setShowAll] = useState(false);

  const faqs = [
    {
      question: "컨설팅 비용은 얼마인가요?",
      answer: "컨설팅 비용은 업종, 사업장 규모, 근로자 수, 서비스 종류에 따라 달라집니다. 무료 견적 신청을 통해 정확한 비용을 안내받으실 수 있으며, 영업일 기준 3일 이내에 견적서를 발송해드립니다."
    },
    {
      question: "컨설팅 기간은 얼마나 걸리나요?",
      answer: "서비스 종류에 따라 다르지만, 일반적으로 위험성평가는 2~3주, 근골격계유해요인조사는 3~4주, 안전보건체계구축은 4~6주 정도 소요됩니다. 급한 경우 별도 협의를 통해 일정 조율이 가능합니다."
    },
    {
      question: "어떤 업종도 가능한가요?",
      answer: "네, 모든 업종의 컨설팅이 가능합니다. 제조업, 건설업, 서비스업, 물류업 등 다양한 업종에서 풍부한 경험을 보유하고 있으며, 각 업종의 특성에 맞는 맞춤형 컨설팅을 제공합니다."
    },
    {
      question: "고용노동부 인증 기관이라는 것은 무엇을 의미하나요?",
      answer: "고용노동부로부터 정식으로 인증받은 교육기관으로, 산업안전보건 관련 직무교육을 진행할 수 있는 자격을 갖춘 기관입니다. 이는 전문성과 신뢰성을 공식적으로 인정받았다는 의미입니다."
    },
    {
      question: "사후관리는 어떻게 진행되나요?",
      answer: "컨설팅 완료 후에도 감독 대응을 위한 증빙자료를 지속적으로 관리해드리며, 추가 문의사항이나 개선사항에 대해 상담을 제공합니다. 정기적인 모니터링을 통해 지속적인 안전관리를 지원합니다."
    },
    {
      question: "무료 자료는 어떻게 받을 수 있나요?",
      answer: "무료 자료 신청 시, 컨설팅을 신청하지 않아도 2026년 최신 감독 지적 사례집과 적발 사례 Top 4 자료를 무료로 제공해드립니다. 또한 자가진단 체크리스트와 세부 분석 리포트, 업종별 유의사항도 함께 받으실 수 있습니다."
    },
    {
      question: "현장 방문은 필수인가요?",
      answer: "대부분의 컨설팅은 정확한 현황 파악을 위해 현장 방문이 필요합니다. 다만, 서비스 종류에 따라 일부는 원격으로 진행 가능한 경우도 있으니 상담 시 문의해주시기 바랍니다."
    },
    {
      question: "계약 후 취소나 환불이 가능한가요?",
      answer: "계약 후 작업 진행 전에는 전액 환불이 가능하며, 작업 진행 정도에 따라 부분 환불이 가능합니다. 자세한 환불 규정은 계약서에 명시되어 있으며, 상담 시 안내해드립니다."
    }
  ];

  const displayedFaqs = showAll ? faqs : faqs.slice(0, 4);

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
            자주 묻는 질문
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-slate-600 leading-relaxed px-4">
            고객님들이 가장 궁금해하시는<br className="sm:hidden" /> 내용을 모았습니다
          </p>
        </div>

        <div className="space-y-4">
          {displayedFaqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl border-2 border-slate-200 overflow-hidden hover:border-blue-600 transition-all duration-300">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-slate-50 transition-colors duration-300"
              >
                <h3 className="text-lg font-semibold text-slate-900 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-8 h-8 flex items-center justify-center flex-shrink-0 bg-blue-100 rounded-full transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-xl text-blue-600"></i>
                </div>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}>
                <div className="px-6 pb-5 pt-2">
                  <p className="text-slate-600 text-base leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <button
            onClick={() => setShowAll(!showAll)}
            className="inline-flex items-center gap-2 px-8 py-3 bg-slate-100 text-slate-700 text-base font-semibold rounded-lg hover:bg-slate-200 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {showAll ? '접기' : '더보기'}
            <i className={`ri-arrow-${showAll ? 'up' : 'down'}-s-line text-xl transition-transform duration-300`}></i>
          </button>
        </div>
      </div>

      <FreeResourceModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
};

export default FAQ;
